import { isPartError, parseParts, PartError } from "./parseParts";
import { PartRunner } from "./runParts";

/** take a string with embedded parts info and play it */
export function playParts(s: string): true | PartError {
  const parts = parseParts(s);
  if (isPartError(parts)) {
    return parts;
  }
  PartRunner.runParts(parts);
  return true;
}
